<template>
    <v-snackbar
        :color="snackbar.message.color"
        :timeout="snackbar.message.timeout"
        :multi-line="snackbar.message.multiline === true"
        absolute top right
        v-model="show">
        {{ snackbar.message.text }}
        <v-icon dark @click.native="closeSnackbar">{{ snackbar.message.icon }}</v-icon>
    </v-snackbar>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    export default {
        name: 'globalSnackbar',
        computed: {
            ...mapGetters({
                show: 'getSnackbarState',
                snackbar: 'getSnackbar'
            }),
            show: {
                get: function () {
                    return this.$store.getters.getSnackbarState
                },
                set: function () {
                    this.$store.commit('closeSnackbar')
                }
            }
        },
        methods: mapMutations(['closeSnackbar'])
    }
</script>
